import {createContext, useContext} from 'react';

export const HighlightsSliderContext = createContext(null);

export const useFullscreenHighlightsSliderContext = () => {
    const context = useContext(HighlightsSliderContext);

    return context;
};
